import { render, staticRenderFns } from "./recommender_informal.vue?vue&type=template&id=f1b23f1a&scoped=true&"
import script from "./recommender_informal.vue?vue&type=script&lang=js&"
export * from "./recommender_informal.vue?vue&type=script&lang=js&"
import style0 from "./recommender_informal.vue?vue&type=style&index=0&id=f1b23f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b23f1a",
  null
  
)

export default component.exports